import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { IconButton } from "../Button/IconButton";
import type { ButtonSize } from "../Button/types";
import { Input } from "./Input";
import type { InputPasswordProps, InputSize } from "./types";

export const InputPassword = (props: InputPasswordProps) => {
  const size: InputSize = props.size || "md";
  const [visible, setVisible] = useState<boolean>(false);

  const onChangeType = () => {
    setVisible((visible: boolean) => !visible);
  };

  const buttonSizeMap: Record<InputSize, ButtonSize> = {
    sm: "xs",
    md: "sm",
    lg: "md",
  };

  return (
    <Input
      {...props}
      autoComplete={props.autoComplete || "off"}
      placeholder={props.placeholder}
      type={visible ? "text" : "password"}
      endAccessory={
        <IconButton
          variant="ghost"
          color="neutral"
          size={buttonSizeMap[size]}
          onClick={onChangeType}
          content={visible ? <EyeOff /> : <Eye />}
        />
      }
    />
  );
};
